import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

@NgModule({
  imports: [AuthModule.forRoot({
    config: {
      authority: environment.authority,
      redirectUrl: `${environment.urlWeb}callback`,
      postLogoutRedirectUri: `${environment.urlWeb}`,
      clientId: environment.clientId,
      scope: 'openid alliance_profile offline_access',
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      renewTimeBeforeTokenExpiresInSeconds: 30
    }
  })],
  exports: [AuthModule],
})
export class AuthConfigModule { }
